import React from 'react';

const CommentSkeleton = () => {
  return (
    <div className="isolate flex h-fit w-full flex-col items-start gap-2 rounded-lg border border-solid border-neutral-200 px-4 py-3">
      <div className="flex w-full flex-row items-center gap-2">
        <div className="h-8 w-8 animate-pulse rounded-full bg-neutral-200" />
        <div className="flex w-full items-center justify-between">
          <div className="h-4 w-24 animate-pulse rounded bg-neutral-200" />
          <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
        </div>
      </div>
      <div className="h-4 w-full animate-pulse rounded bg-neutral-200" />
      <div className="h-4 w-3/4 animate-pulse rounded bg-neutral-200" />
    </div>
  );
};

export default CommentSkeleton;
